/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit';
import { initialState } from './defaultState';
import { setLoader } from './actions';

const loaderReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setLoader, (state, action) => {
      state[action.payload.loader] = action.payload.isLoading;
    });
});

export default loaderReducer;
